import { call, put, takeEvery } from "redux-saga/effects";
import { nhomLopSinhVienApi } from "../../../api/category/nhomLopSinhVienApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eNhomLopSinhVienActionIds, INhomLopSinhVienActionTypes } from "../../action-types/category/INhomLopSinhVienActions";
import { rootActions } from "../../actions/rootActions";
import { INhomLopSinhVien } from "../../../model/respone/category/INhomLopSinhVien";
import { INhomLopSinhVienInsertRequest } from "../../../model/request/category/INhomLopSinhVienInsertRequest";

export function* nhomLopSinhVienSaga(): any {
  yield takeEvery(eNhomLopSinhVienActionIds.LOAD_START, loadWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.ADD_START, addWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.DELETES_START, deletesWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.ADDS_START, addsWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.SCAN_ADD_PREVIEW_START, scanAddPreviewWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.SCAN_ADD_START, scanAddWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.SCAN_REMOVE_PREVIEW_START, scanRemovePreviewWorker);
  yield takeEvery(eNhomLopSinhVienActionIds.SCAN_REMOVE_START, scanRemoveWorker);
}

function* loadWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.SelectByNhomLops, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* addWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.Insert, action.payload as INhomLopSinhVien);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.ADD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.ADD_ERROR(res.message ?? "Có lỗi"));
  }
}

function* deletesWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.Deletes, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.DELETES_SUCCESS(undefined));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.DELETES_ERROR(res.message ?? "Có lỗi"));
  }
}

function* addsWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.AddSinhViens, action.payload as INhomLopSinhVienInsertRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.ADDS_SUCCESS(undefined));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.ADDS_ERROR(res.message ?? "Có lỗi"));
  }
}

function* scanAddPreviewWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.ScanAddByLopPreview, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_ADD_PREVIEW_SUCCESS(res.data ?? []));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_ADD_PREVIEW_ERROR(res.message ?? "Có lỗi"));
  }
}

function* scanAddWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.ScanAddByLop, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_ADD_SUCCESS(undefined));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_ADD_ERROR(res.message ?? "Có lỗi"));
  }
}

function* scanRemovePreviewWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.ScanRemoveByLopPreview, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_REMOVE_PREVIEW_SUCCESS(res.data ?? []));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_REMOVE_PREVIEW_ERROR(res.message ?? "Có lỗi"));
  }
}

function* scanRemoveWorker(action: INhomLopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopSinhVienApi.ScanRemoveByLop, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_REMOVE_SUCCESS(undefined));
  } else {
    yield put(rootActions.category.nhomLopSinhVien.SCAN_REMOVE_ERROR(res.message ?? "Có lỗi"));
  }
}